import * as Yup from "yup";

export const supportSchema = Yup.object().shape({
  name: Yup.string().required("Title is required."),
  email: Yup.string()
    .email("Please enter a valid email address.")
    .required("Email is required."),
  phoneNumber: Yup.string().required("Phonenumber is required."),
  query: Yup.string().required("Query is required."),
  ticketStatus: Yup.string().required("Ticketstatus is required."),
});
